// @flow
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import Trpc from 'digicel-kaizen-library/lib/tripica-library';
import { tripica } from '../../api';
import { promotionSelector } from '../SignUp/Bonus/reducer';
import { clearAgreements, setAgreementSpecifications } from './actions';
import { swapBackupAndCurrentSubscriptionOuid } from '../Dashboard/actions';
import { setLoading } from '../LoadingStatus';
import { newOfferOptionsSelector } from '../NewOffer/selectors';
import { currentSubscriptionSelector } from '../Dashboard';

export function* setAgreementSpecificationSaga(action: any): Generator<*, *, *> {
  yield put(setLoading('confirmPlan', true));

  const currentSubscription = yield select(currentSubscriptionSelector);

  if (action.payload.isSignup && currentSubscription != null) {
    yield put(swapBackupAndCurrentSubscriptionOuid());
  }

  const promotion = yield select(promotionSelector);
  const catalog = yield call([tripica, 'getCatalog']); // FUTURE store catalog?
  let formattedProductOfferings: Object[] = [];
  let agreementSpecifications;

  yield put(clearAgreements());

  if (catalog.allOptions) {
    let options;
    if (action.payload && action.payload.options) {
      options = action.payload.options;
    } else {
      options = yield select(newOfferOptionsSelector);
    }

    formattedProductOfferings =
      options && options
        .filter(option => catalog.allOptions[option.type])
        .map(option => Trpc.getCatalogByProductName(option.name, catalog.allOptions[option.type]))
        .filter(Boolean);
  }

  if (promotion && promotion.productOffering) {
    formattedProductOfferings.push(promotion.productOffering);
  }

  const kaizenSubscriptionName = Trpc.getSubscriptionProductName();
  const subscriptionProductOffering = catalog.allSubscriptions.find(
    productOffering => productOffering.name === kaizenSubscriptionName
  );

  if (subscriptionProductOffering) {
    formattedProductOfferings.push(subscriptionProductOffering);
  }

  formattedProductOfferings.push(catalog.allPlans[0]);
  agreementSpecifications = yield call([tripica, 'getCurrentAgreements'], formattedProductOfferings);
  yield put(setAgreementSpecifications(agreementSpecifications));
  yield put(setLoading('confirmPlan', false));
}

export default function*(): Generator<*, *, *> {
  yield all([takeEvery('FETCH_AGREEMENTS_BY_PRODUCT_OFFERINGS', setAgreementSpecificationSaga)]);
}
